<template>
  <div>
    <transition mode="out-in">
      <div v-if="loading">
        <loading-spinner />
      </div>
      <div v-else-if="saved">
        Password updated successfully!
      </div>
      <form v-else-if="user.magic" @submit.prevent="savePassword">
        <div class="input-group mb-4">
          <input :type="showPassword ? `text` : `password`" class="form-control form-control-lg" v-model="password" placeholder="New Password" />
          <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="showPassword=!showPassword">
            <i class="bi" :class="{'bi-eye':!showPassword,'bi-eye-slash':showPassword}"></i>
          </button>
        </div>

        <div class="d-flex">
          <button type="submit" :disabled="password.length < 8" class="btn btn-primary ms-auto">Save Password</button>
        </div>

      </form>
      <div v-else>
        <button type="button" class="btn btn-light btn-outline-primary" @click="resetPassword">Reset Password</button>
      </div>
    </transition>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {useStore} from "vuex";
import LoadingSpinner from "@/app/components/Utils/LoadingSpinner.vue";
const store = useStore();
const user = computed(() => store.state.user);
const password = ref("");
const showPassword = ref(false);
const saved = ref(false);
const loading = ref(false);

async function resetPassword(){
  await store.dispatch("resetPassword");
}

async function savePassword() {
  loading.value = true;
  const success = await store.dispatch("savePassword", password.value);
  if (success) {
    loading.value = false;
    saved.value = true;
    setTimeout(() => saved.value = false, 1500);
  }

}
</script>

<style lang="scss" scoped>

</style>
